import TermsAndPolicy from './TermsAndPolicy';
export default TermsAndPolicy;
